(function() {
  'use strict';

  angular.module('ringbaPortal.services').factory('mediaQueryService', mediaQueryService);

  function mediaQueryService() {
    'ngInject';
    
    const defaultRules = {
      lg: '(min-width: 1200px)',
      md: '(min-width: 992px) and (max-width: 1199px)',
      sm: '(min-width: 768px) and (max-width: 991px)',
      xs: '(max-width: 767px)',
      mdMax: '(max-width: 1199px)'
    };

    const service = {
      evaluateMediaQuery: evaluateMediaQuery
    };

    return service;

    function evaluateMediaQuery(rule) {
      return window.matchMedia(defaultRules[rule]).matches;
    }
  }

})();
